import { Backbone, moment } from "../../vendor";
import { Biscuit } from "../utils";
import InboomaBaseController from "./InboomaBaseController";

import DashboardWidget from "../views/dashboard/DashboardWidget";
import LocationsView from "../views/contingents/LocationsView";

import DashboardViewTpl from "../templates/dashboard/DashboardViewTpl.html";
import { dateCompare } from "../react/pages/openingTimes/utility/momentPoly";

// @todo Ensure that all onClick events become
// detached after view is change

export default InboomaBaseController.extend({
  _el: "#inb-c",
  _template: DashboardViewTpl,
  _channelName: "dashboard",

  _shouldRenderLayout() {
    return Biscuit.get("user.role") !== "user";
  },

  index() {
    /*
    if (Biscuit.get('user.role') === 'user') {
        Backbone.history.navigate('reservationsList', { trigger:true });
        document.body.classList.remove('view-dashboard'); // Required
        return;
    }
*/
    let orders;

    const that = this,
      //contingentsController = this.app.request('get:router', 'contingents'),
      //ordersController = this.app.request('get:router', 'orders');
      reservationsListController = this.app.request("get:router", "reservationsList");

    this.locationsView = new LocationsView({
      widgetMode: true,
      el: "#map",
    });

    // fill statistic widgets with content - request data
    let reservationFilter = "begin_lt=" + moment().format("YYYY-MM-DD HH:mm:ss");
    reservationFilter += "&end_gte=" + moment().format("YYYY-MM-DD HH:mm:ss");
    reservationFilter += "&finder=NotCancelled";

    let reservationCounts = {
      inprogress: null,
      completed: null,
      confirmed: null,
    };

    const RequestHelper1 = Backbone.Model.extend({
      urlRoot: "/reservations?limit=5&page=1&" + reservationFilter + "&status=inprogress",
    });

    new RequestHelper1().fetch({
      success(model, response) {
        reservationCounts.inprogress = model.attributes.pagination.count;
        that._checkinRequestFinished(reservationCounts);
      },
    });

    const RequestHelper2 = Backbone.Model.extend({
      urlRoot: "/reservations?limit=5&page=1&" + reservationFilter + "&status=completed",
    });

    new RequestHelper2().fetch({
      success(model, response) {
        reservationCounts.completed = model.attributes.pagination.count;
        that._checkinRequestFinished(reservationCounts);
      },
    });

    const RequestHelper3 = Backbone.Model.extend({
      urlRoot: "/reservations?limit=5&page=1&" + reservationFilter + "&status=confirmed",
    });

    new RequestHelper3().fetch({
      success(model, response) {
        reservationCounts.confirmed = model.attributes.pagination.count;
        that._checkinRequestFinished(reservationCounts);
      },
    });

    let resourceFilter = "/resources?limit=5&page=1";
    // userLocations = [];

    let resourceCounts = {
      available: null,
      total: null,
    };
    /*
    if (Biscuit.get('user.role') == 'manager-location') {
      userLocations = Biscuit.get('user.user_locations').split(',');

      if (userLocations.length > 0) {
        resourceFilter += "&location_id=" + userLocations[0];
      }
    }
*/

    const RequestHelper4 = Backbone.Model.extend({
      urlRoot: resourceFilter + "&find=!checkedIn&status=active",
    });

    new RequestHelper4().fetch({
      success(model, response) {
        resourceCounts.available = model.attributes.pagination.count;
        that._resourceRequestFinished(resourceCounts);
      },
    });

    const RequestHelper5 = Backbone.Model.extend({ urlRoot: resourceFilter });

    new RequestHelper5().fetch({
      success(model, response) {
        resourceCounts.total = model.attributes.pagination.count;
        that._resourceRequestFinished(resourceCounts);
      },
    });

    const RequestHelper6 = Backbone.Model.extend({ urlRoot: "/users?limit=5&page=1" });

    new RequestHelper6().fetch({
      success(model, response) {
        document.getElementById("user-statistics-label").innerHTML =
          model.attributes.pagination.count;
      },
    });

    //this.ordersWidget = new DashboardWidget({
    this.reservationsWidget = new DashboardWidget({
      el: "#inb-c-main-dashboard-orders",
      title: that.t("reservations", null, "capital"),
      addButton: {
        title: that.t("add_${a}", { a: that.t("order") }),
        link: "/reservationsList/add",
      },
      /*tabs : [
        {
          title : that.t('upcoming'),
          onClick : () => {
            orders.proxy.filterDateBeginBiggerThan(moment().hours(0).minutes(0).seconds(0).milliseconds(0).format('X'));
          },
          active : true,
        },
        {
          title : that.t('past'),
          onClick : () => {
            orders.proxy.removeFilter('date-begin')
                        .removeFilter('date-end')
                        .filterDateBeginSmallerThan(moment().hours(0).minutes(0).seconds(0).milliseconds(0).format('X'));
          }
        }
      ],*/
      onBeforeRender() {
        //ordersController.controller.loadDependencies(ordersController.dependencies)
        reservationsListController.controller
          .loadDependencies(reservationsListController.dependencies)
          .then(function () {
            if (document.querySelector("#inb-c-main-dashboard-orders") !== null) {
              //ordersController.controller.index({ widgetMode: true, el: '#inb-c-main-dashboard-orders' });
              reservationsListController.controller.index({
                widgetMode: true,
                el: "#inb-c-main-dashboard-orders",
              });
              // orders = Radio.channel('orders').request('get:data');
              //orders.proxy.filterDateBeginBiggerThan(moment().hours(0).minutes(0).seconds(0).milliseconds(0).format('X'));
            }
          });
      },
    });
  },

  _checkinRequestFinished(data) {
    if (data.inprogress != null && data.completed != null && data.confirmed != null) {
      // all requests finished, show statistics
      console.log("All requests finished");
      document.getElementById("checkin-statistics-label").innerHTML =
        data.inprogress +
        data.completed +
        "/" +
        (data.inprogress + data.completed + data.confirmed);
    }
  },

  _resourceRequestFinished(data) {
    if (data.available != null && data.total != null) {
      // all requests finished, show statistics
      console.log("All resource requests finished");
      if (data.total == 0) {
        // no resources configured - hide statistics, move up user statistics
        document.getElementById("dashboard-contingent-statistics").className += " hide";
        document.getElementById("dashboard-user-statistics").style = "margin-top: 116px;";
      } else {
        document.getElementById("contingent-statistics-label").innerHTML =
          data.available + "/" + data.total;
      }
    }
  },
});
